$(document).ready(function () {
	$('.questions-t .qt[data-type=1]').each(function (i, q) {
		$(q).find('input[type=checkbox], input[type=radio]').on('change', function () {
			Lection.cacheHomework();
		});
	});
});